import { t } from "utilities/lang";

export const customLocale = {
  lang: {
    locale: 'en_US',
    yearPlaceholder: t('date_picker.select_year'),
    quarterPlaceholder: t('date_picker.select_quarter'),
    monthPlaceholder: t('date_picker.select_month'),
    weekPlaceholder: t('date_picker.select_week'),
    rangePlaceholder: [t('date_picker.range_date_placeholder_start'), t('date_picker.range_date_placeholder_end')],
    rangeYearPlaceholder: [
      t('date_picker.range_year_placeholder_start'),
      t('date_picker.range_year_placeholder_end'),
    ],
    rangeQuarterPlaceholder: [
      t('date_picker.range_quarter_placeholder_start'),
      t('date_picker.range_quarter_placeholder_end'),
    ],
    rangeMonthPlaceholder: [
      t('date_picker.range_month_placeholder_start'),
      t('date_picker.range_month_placeholder_end'),
    ],
    rangeWeekPlaceholder: [
      t('date_picker.range_week_placeholder_start'),
      t('date_picker.range_week_placeholder_end'),
    ],
    rangeDatePlaceholder: [
      t('date_picker.range_date_placeholder_start'),
      t('date_picker.range_date_placeholder_end'),
    ],
    rangeTimePlaceholder: [
      t('date_picker.range_time_placeholder_start'),
      t('date_picker.range_time_placeholder_end'),
    ],
    datePlaceholder: t('date_picker.select_date'),
    timePlaceholder: t('date_picker.select_time'),
    today: t('date_picker.footer.today'),
    now: t('date_picker.now'),
    backToToday: t('date_picker.back_to_today'),
    ok: t('common.ok'),
    clear: t('date_picker.clear'),
    month: t('date_picker.month'),
    year: t('date_picker.year'),
    timeSelect: t('date_picker.select_time'),
    dateSelect: t('date_picker.select_date'),
    weekSelect: t('date_picker.choose_week'),
    monthSelect: t('date_picker.choose_month'),
    yearSelect: t('date_picker.choose_year'),
    decadeSelect: t('date_picker.choose_decade'),
    yearFormat: 'YYYY',
    dateFormat: 'M/D/YYYY',
    dayFormat: 'D',
    dateTimeFormat: 'M/D/YYYY HH:mm:ss',
    monthBeforeYear: true,
    previousMonth: t('date_picker.previous_month'),
    nextMonth: t('date_picker.next_month'),
    previousYear: t('date_picker.previous_year'),
    nextYear: t('date_picker.next_year'),
    previousDecade: t('date_picker.previous_decade'),
    nextDecade: t('date_picker.next_decade'),
    previousCentury: t('date_picker.previous_century'),
    nextCentury: t('date_picker.next_century'),
    shortWeekDays: t('date_picker.short_weekdays').split(','),
    weekDays: t('date_picker.weekdays').split(','),
    shortMonths: t('date_picker.short_months').split(','),
  },
};